﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";
import { IToast } from "../../Interface/IToast"
import { GuiFilterSortClient } from "../../GuiFilterSortClient"

export class GuiDetailFaktura extends GuiDetailGeneric {


    selectorErzList: string = "#faktura-aktion";

    constructor() {
        super("Abrechnung");
    }

    attachEvents() {
        super.attachEvents();

        //const guiFilterSort = new GuiFilterSort($("#faktura-aktion"), () => this.attachListEvents());

        $("#btnFakturaAktionChoose").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickFakturaAktionChoose(e));
        $("#btnFakturaAdbChoose").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickFakturaAdbChoose(e));

        const listFakturaAktion = $("#faktura-aktion");
        new GuiFilterSortClient(listFakturaAktion, 
            (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>)=>this.clickDetailRow(e));

        // mouseover Image
        $("div.icons img").on("mouseover", (e: JQuery.MouseOverEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.mouseOver(e); });
        $("div.icons img").on("mouseout", (e: JQuery.MouseOutEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.mouseOut(e); });

        $("div.ocr-display input:checkbox").on("change", (e: JQuery.ChangeEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.changeCheckboxOcr(e); });

        $("button.btn-ocr-page").on("click", (e: JQuery.ClickEvent) => { this.clickOcrPage(e); });

    }

    clickOcrPage(e: JQuery.ClickEvent) {
        this.log("clickOcrPage");
        e.preventDefault();
        //var ele = e.Element;
        const btn = $(e.currentTarget);
        let url = $("#ocrdata").data("preview-url").toString();
        const seite = btn.data("seite") as string;
        const ocrDokumentId = $("#ocrdata").data("ocrdokumentid").toString();
        url = `${url}?ocrDokumentId=${ocrDokumentId}&seite=${seite}`;

        $("#mdlOcrDokument").remove();

        $.get(url).done(

            (data: string) => {
                const modalDiv = data;
                $("#detailForm").append($(modalDiv));
                $("#mdlOcrDokument").modal("show");
            });
    }

    //override
    clickDetailRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickDetailRow");

        const ele = $(e.currentTarget);
        const head = ele.closest("div.erz-detail-list");
        const baseurl = head.data("url-detail"); // goto url im Kopf

        const id = $(e.currentTarget).closest("div.erz-list-element").data("id");
        const fakturaId = $("#VmDetail_FakturaId").val();

        const url = `${baseurl}?id=${id}&fakturaid=${fakturaId}`;
        this.gotoUrl(url);
    }

    clickFakturaAktionChoose(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickFakturaAktionChoose");
        this.doAction(e);
    }

    clickFakturaAdbChoose(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickFakturaAdbChoose");
        this.doAction(e);
    }

    mouseOver(e: JQuery.MouseOverEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        const $img = $(e.currentTarget);
        $("div.icons div.card").css({ "z-index": "0" });
        $img.closest(".card").css({ "z-index": "100" });

        const pos = $(e.currentTarget).data("pos");
        const url = $("div.icons").data("previewurl");
        const img = $(e.currentTarget)[0] as HTMLImageElement;
        const imgUrl = url + "?pos=" + pos;
        $(img).data("iconurl", img.src);
        img.src = imgUrl;
        img.style.transform = "scale(8)";
        img.style.transition = "transform 1s ease";
        img.style.border = ".5px solid grey";
        img.style.zIndex = "1000";
    }

    mouseOut(e: JQuery.MouseOutEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        //var pos= $(e.currentTarget).data("pos");
        //var url = $("div.icons").data("previewurl");
        const img = $(e.currentTarget)[0] as HTMLImageElement;

        img.style.transform = "scale(1)";
        img.style.transition = "transform .5s ease";
        img.style.zIndex = "1";
        img.style.border = "";
        img.src = $(img).data("iconurl");
    }

    changeCheckboxOcr(e: JQuery.ChangeEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("changeCheckboxOcr");
        const divRow = $(e.currentTarget).closest(".erz-list-element-display");
        const ocrDokumentPositionId = divRow.data("id");
        const url = $("div.ocr-display").data("url-ignoreocr") + "?ocrDokumentPositionId=" + ocrDokumentPositionId;
        
        $.get(url).done(() => {
            let text = "";
            if ($(e.currentTarget).is(":checked")) {
                divRow.addClass("erz-list-element-inaktiv");
                text = "Zeile aktiviert";
            } else {
                divRow.removeClass("erz-list-element-inaktiv");
                text = "Zeile deaktiviert";
            }

            const toast: IToast = {
                level: "Zeile bearbeitet",
                message: text,
                title: "OCR",
                duration: 2000
            };
            this.showToasts([toast]);
        });

    }
}
